<template>
  <div>
    <v-simple-table fixed-header fixed-footer height="350px" class="elevation-0">
      <template v-slot:default>
        <thead>
          <tr>
            <th style="width: 42px;"></th>
            <th class="text-left">Quantity/Weight</th>
            <th class="text-left">Unit Type</th>
            <th class="text-left">Date Added</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in raw_material_inventories" :key="item.pivot.id" style="cursor: pointer">
            <td>
              <input
                type="checkbox"
                v-model="rawmaterialinventoriesChecked"
                :ref="`raw_material_inventories${item.pivot.id}`"
                :value="item.pivot.id"
              />
            </td>
            <td class="text-left">{{ parseFloat(item.pivot.quantity).toLocaleString() }}</td>
            <td class="text-left">{{ item.unit_type }}</td>
            <td class="text-left">{{ item.created_at }}</td>
          </tr>
          <tr v-if="raw_material_inventories.length == 0">
            <td colspan="5" style="height:300px;text-align: center">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card elevation="0">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="rawmaterialinventoriesChecked.length == 0"
          outlined
          color="red"
          @click="deleteRawMaterialInventories"
        >
          DELETE RAW MATERIALS
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import confirm from '../../components/Confirm.vue';

export default {
  props: ['raw_material_inventories', 'checkbox'],
  data: function() {
    return {
      print: false,
      rawmaterialinventoriesChecked: []
    };
  },
  components: {
    confirm
  },
  methods: {
    ...mapActions(['RawMaterial/getRawMaterial']),
    deleteRawMaterialInventories() {
      this.$refs.confirm
        .open('Delete Added Quantity', 'Are you sure you want to delete stocks?', {
          color: '#f44336'
        })
        .then(confirm => {
          axios
            .delete(`api/v1/rawmaterial/${this.$route.params.id}/deletequantity`, {
              params: { rawmaterialinvetoryids: this.rawmaterialinventoriesChecked }
            })
            .then(response => {
              console.log(response.data);
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Stocks deleted...',
                color: 'success'
              });
              this['RawMaterial/getRawMaterial']({ id: this.$route.params.id });
            })
            .catch(response => {
              this.errorMessages = response.response.data.errors;
            })
            .finally(() => {});
        });
    }
  }
};
</script>
